






























































import { Component, Vue } from 'vue-property-decorator';
import { addressList, delAddress, defaultAddress, getNextAddress } from '@/utils/api';
import { addressForm } from '../interface';

interface form {
  userName: string;
  iphone: string;
  value1: string;
  value2: string;
  value3: string;
}
@Component
export default class returnSearch extends Vue {
  $bus: any;
  options1: Array<Object> = [];
  options2: Array<Object> = [];
  options3: Array<Object> = [];
  formInline: form = {
    userName: '',
    iphone: '',
    value1: '',
    value2: '',
    value3: '',
  };
  // 收集请求列表数据
  addressForm: addressForm = {
    addressType: 'REFUND_GOODS_ADDRESS',
    // 地址类型：REFUND_GOODS_ADDRESS，退货地址；DELIVER_GOODS_ADDRESS，发货地址
    cityId: null,
    // 市Id
    districtId: null,
    // 区Id
    iphone: null,
    // 联系人手机号
    ownerCode: null,
    // 所属人
    page: 0,
    // 页码
    postCode: null,
    // 邮政编码
    provinceId: null,
    // 省Id
    size: 20,
    // 条数
    streetId: null,
    // 街道Id
    telephone: null,
    userName: null,
    // 联系人
  };
  mounted() {
    this.getNextAddress(null, null);
  }
  // select 实现三级联动
  getsCurrent1(e) {
    this.getNextAddress({ addressId: e }, 'two');
    this.formInline.value2 = null;
    this.formInline.value3 = null;
  }
  getsCurrent2(e) {
    this.getNextAddress({ addressId: e }, 'three');
    this.formInline.value3 = null;
  }
  // 请求省市区地址接口
  async getNextAddress(params, num) {
    try {
      let resultData = await getNextAddress(params);
      if (!params) {
        this.options1 = resultData;
      } else if (num == 'two') {
        this.options2 = resultData;
      } else if (num == 'three') {
        this.options3 = resultData;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //查询
  searchButton() {
    let { userName, iphone, value1, value2, value3 } = this.formInline;
    let addressForm = {
      ...this.addressForm,
      userName,
      iphone,
      provinceId: value1,
      cityId: value2,
      districtId: value3,
      provinceName: this.$refs['getValue1']['$children'][0].nativeInputValue,
      cityName: this.$refs['getValue2']['$children'][0].nativeInputValue,
      districtName: this.$refs['getValue3']['$children'][0].nativeInputValue,
    };
    this.$bus.$emit('searchForm', addressForm);
  }
  // 重置
  cancelButton() {
    this.$refs['searchForm']['resetFields']();
    this.options2 = null;
    this.options3 = null;
    this.$bus.$emit('searchForm', this.addressForm);
  }
}
